import { render, staticRenderFns } from "./licensePop.vue?vue&type=template&id=0824b6a4"
import script from "./licensePop.vue?vue&type=script&lang=js"
export * from "./licensePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0824b6a4')) {
      api.createRecord('0824b6a4', component.options)
    } else {
      api.reload('0824b6a4', component.options)
    }
    module.hot.accept("./licensePop.vue?vue&type=template&id=0824b6a4", function () {
      api.rerender('0824b6a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/license/licensePop.vue"
export default component.exports